import { Directive, HostListener, ElementRef, Input } from '@angular/core';
/* import { Directive, HostListener, ElementRef } from '@angular/core';

@Directive({
  selector: '[appMaxInputLimit]',
})


export class MaxInputLimitDirective {

  private maxLength = 155;

  constructor(private el: ElementRef) { }

  @HostListener('input', ['$event']) onInputChange(event: Event) {
    const input = this.el.nativeElement as HTMLInputElement;
    if (input.value.length > this.maxLength) {
      input.value = input.value.slice(0, this.maxLength);
    }
  }
} */


@Directive({
  selector: '[appMaxInputLimit]',
})
export class MaxInputLimitDirective {

  @Input() maxLength: number = 155; // Default max length  155

  constructor(private el: ElementRef) { }

  @HostListener('input', ['$event']) onInputChange(event: Event) {
    const input = this.el.nativeElement as HTMLInputElement;
    if (input.value.length > this.maxLength) {
      input.value = input.value.slice(0, this.maxLength);
    }
  }
}

